import ModalComponent from 'components/Common/Modal';
import { useEffect, useRef, useState } from 'react';
import useEmailComponentFunctions from 'components/Dashboard/Influence/CrmEmails/useEmailComponentFunctions';
import useMailMergeFunctions from 'components/Dashboard/Influence/CrmEmails/MailMergeSection/useMailMergeFunctions';
import { useLocation, useNavigate } from 'react-router-dom';

const ViewMailMergeModal = ({ isOpen, setIsOpen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [csvData, setCsvData] = useState(null);
  const { saveEmail } = useEmailComponentFunctions();
  const { viewMailMerge } = useMailMergeFunctions();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.openViewMailMerge) {
      setIsOpen(location.state.openViewMailMerge);
      setTimeout(() => {
        navigate(
          {
            state: {},
          },
          { replace: true }
        );
      }, 300);
    }
  }, [location.state]);

  useEffect(() => {
    if (!isOpen) {
      setCsvData(null);
      setIsLoading(false);
    }
  }, [isOpen]);

  const save = useRef(null);
  save.current = async (source) => {
    setIsLoading(true);
    try {
      let res = await saveEmail({
        notRedirect: true,
        noNotification: true,
        returnResult: true,
        source,
      });
      if (res) {
        const result = await viewMailMerge({ id: res.crmEmailId });
        if (result) {
          setCsvData(result);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    } catch {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const source = new AbortController();
    if (!location.state?.openViewMailMerge && isOpen) {
      save.current(source);
    }
    return () => {
      source.abort('Use mail merge cancelled by the user');
    };
  }, [isOpen]);

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} maxWidth={1200} style={{ height: '80vh' }}>
      <div className='d-flex flex-column h-100'>
        <h4 className='popup-header px-3 px-lg-5 mt-4 mb-3 title-h4-bold'>Mail merge data</h4>
        <div className='separator' />
        <div className='flex-grow-1 overflow-auto px-3 pb-3 mt-2'>
          {isLoading ? (
            <div className='d-flex justify-content-center align-items-center h-100 pb-5'>
              <i className='fas fa-spinner fa-spin d-inline-block-centered' style={{ fontSize: '36px' }} />
            </div>
          ) : (
            <>
              {csvData && csvData.headers.length > 0 ? (
                <table className='paragraph-p1 w-100'>
                  <thead className='border-bottom position-sticky top-0 z-10' style={{ backgroundColor: '#f9f7f6' }}>
                    <tr>
                      {csvData.headers.map((header, index) => (
                        <th key={index} className='p-2 nowrap-item'>
                          {header || `Column ${index + 1}`}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {csvData.rows.map((row, rowIndex) => (
                      <tr key={rowIndex} className='border-bottom'>
                        {csvData.headers.map((_, colIndex) => (
                          <td key={colIndex} className='p-2'>
                            {row[colIndex] || ''}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='text-center p-4 text-main-blue-45'>No data available</div>
              )}
            </>
          )}
        </div>
      </div>
    </ModalComponent>
  );
};
export default ViewMailMergeModal;
